<dx-resizable [width]="size.Width"
               [height]="size.Height"
               [minWidth]="100"
               [minHeight]="100"
               (onResize)="onResize($event)"
               class="ep-chart">

    <p class="grid-header">{{chartConfiguration?.Header}}</p>

    <dx-data-grid id="grid"
                  [dataSource]="valueFields"
                  [showRowLines]="true"
                  [columnAutoWidth]="true"
                  [showColumnHeaders]="false"
                  [height]="innerSize.Height-70"> <!-- The minus 70 is to deduct the height of the grid-header element, preventing the grid data from overflowing the container. -->
        
        <dxo-tooltip [enabled]="true"></dxo-tooltip>
        <dxo-paging [enabled]="false"></dxo-paging>
    </dx-data-grid>
</dx-resizable>

<style>
    .grid-header {
        font-family: 'Segoe UI Light', 'Helvetica Neue Light', 'Segoe UI', 'Helvetica Neue', 'Trebuchet MS', Verdana;
        font-size: 28px;
        margin-top: 0px;
        margin-bottom: 30px;
        text-align: center;
        color: #000000;
    }
</style>